import React, { useEffect, useState } from "react";
import MyMap from "../../Map/Views/MyMap";
import "./Sidebar.css";
import SidebarKatmanlar from "./SidebarKatmanlar";
import SidebarOlcumler from "./SidebarOlcumler";
import SidebarCizimler from "./SidebarCizimler";

import MyLocationIcon from "@material-ui/icons/MyLocation";
import LayersIcon from "@material-ui/icons/Layers";
import CenterFocusWeakIcon from "@material-ui/icons/CenterFocusWeak";
import StraightenIcon from "@material-ui/icons/Straighten";
import BrushIcon from "@material-ui/icons/Brush";
import ZoomInIcon from "@material-ui/icons/ZoomIn";
import ZoomOutIcon from "@material-ui/icons/ZoomOut";
import { fromLonLat } from "ol/proj";

import {
  changeUserPosition,
  userPositionLayer,
} from "../../Map/Layers/userPositionLayer";

export default function Sidebar() {
  const [userLocation, setUserLocation] = useState(null);
  const [selectedPage, setSelectedPage] = useState(0);

  const onClickFunc = (page) => setSelectedPage(page);

  const setMapZoomLevel = (zoomIn) => {
    const view = MyMap.getView();
    view.setZoom(view.getZoom() + (zoomIn ? 0.5 : -0.5));
  };

  const onClickMapCenter = () => {
    MyMap.getView().setZoom(1);
  };

  const onClickZoomUser = () => {
    if (!userLocation) {
      alert("Konum Bilgileri Paylaşılmamış.");
      return;
    }

    const center = fromLonLat(userLocation);

    MyMap.getView().setCenter(center);
    MyMap.getView().setZoom(15);

    changeUserPosition(center[0], center[1]);
  };

  // useEffect(() => {
  //   MyMap.addLayer(userPositionLayer);

  //   // Statik koordinatı direkt lon-lat formatında set edelim:
  //   const lon = 39.73892464477556;
  //   const lat = 40.99695413071831;

  //   setUserLocation([lon, lat]);

  //   return () => {
  //     MyMap.removeLayer(userPositionLayer);
  //   };
  // }, []);

  useEffect(() => {
    MyMap.addLayer(userPositionLayer);

    navigator.geolocation.getCurrentPosition((pos) => {
      const lat = pos.coords.latitude;
      const lon = pos.coords.longitude;

      // OpenLayers için doğru format: [lon, lat]
      setUserLocation([lon, lat]);

      // Map’e işlemek istersen pozisyonu da güncelle
      const center = fromLonLat([lon, lat]);
      changeUserPosition(center[0], center[1]);
    });

    return () => {
      MyMap.removeLayer(userPositionLayer);
    };
  }, []);

  return (
    <>
      <div id="sidebarMenu">
        {selectedPage === 0 && (
          <div className="sideBarBtnGroup">
            <div
              onClick={onClickMapCenter}
              title="Harita Merkezine Git"
              className="sideBarBtn d-flex justify-content-center"
            >
              <CenterFocusWeakIcon fontSize="medium" />
            </div>

            <div
              onClick={onClickZoomUser}
              title="Konumuma Git"
              className="sideBarBtn d-flex justify-content-center"
            >
              <MyLocationIcon fontSize="medium" />
            </div>

            <div
              onClick={() => onClickFunc(1)}
              title="Katmanlar"
              className="sideBarBtn d-flex justify-content-center"
            >
              <LayersIcon fontSize="medium" />
            </div>

            <div
              onClick={() => onClickFunc(2)}
              title="Uzunluk / Alan Ölçümü"
              className="sideBarBtn d-flex justify-content-center"
              style={{ display: "none" }}
            >
              <StraightenIcon fontSize="medium" />
            </div>

            <div
              onClick={() => onClickFunc(3)}
              title="Haritada Çizim Yap"
              className="sideBarBtn d-flex justify-content-center"
              style={{ display: "none" }}
            >
              <BrushIcon fontSize="medium" />
            </div>

            <div
              onClick={() => setMapZoomLevel(true)}
              title="Haritaya Yakınlaş"
              className="sideBarBtn d-flex justify-content-center"
            >
              <ZoomInIcon fontSize="medium" />
            </div>

            <div
              onClick={() => setMapZoomLevel(false)}
              title="Haritadan Uzaklaş"
              className="sideBarBtn d-flex justify-content-center"
            >
              <ZoomOutIcon fontSize="medium" />
            </div>
          </div>
        )}
      </div>

      {/* Sağ Panel */}
      {selectedPage === 1 && (
        <div id="sideBarKatmanlar" className="sideBarForm">
          <i
            className="far fa-window-close fa-lg sideBarCloseBtn"
            onClick={() => setSelectedPage(0)}
          ></i>
          <SidebarKatmanlar />
        </div>
      )}
      {selectedPage === 2 && (
        <div id="sideBarOlcumler" className="sideBarForm">
          <i
            className="far fa-window-close fa-lg sideBarCloseBtn"
            onClick={() => setSelectedPage(0)}
          ></i>
          <SidebarOlcumler />
        </div>
      )}
      {selectedPage === 3 && (
        <div id="sideBarCizimler" className="sideBarForm">
          <i
            className="far fa-window-close fa-lg sideBarCloseBtn"
            onClick={() => setSelectedPage(0)}
          ></i>
          <SidebarCizimler />
        </div>
      )}
    </>
  );
}
